import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import $store from '@/store'
import EditorJS from '@/_models/editorJS'

export interface LogParam {
    'filter[activityLogEntityId]': string
    'filter[activityLogNumber]'?: Array<string>
    'filter[eventName]'?: Array<string>
    'filter[entityId]'?: string | null
    'filter[time][gt]'?: string
    'filter[time][lt]'?: string
    sort?: 'time' | '-time'
    'page[offset]'?: number
    'page[limit]'?: number
}

export default class Log extends JsonApiObject {
    static limit = 50

    public constructor(data: any, included?) {
        super(data, included)
    }

    sourceService
    eventName
    time
    projectId
    entityId
    activityLogEntityId
    activityLogNumber
    payload

    get hasActingUser() {
        return this._relationships['actingUser'] ? true : false
    }

    get actingUser() {
        return this.hasActingUser ? this._relationships['actingUser'] : null
    }

    get email() {
        return this['payload'].email
    }

    get pendingEmail() {
        return this['payload'].pendingEmail
    }

    get pendingDisplayName() {
        return this['payload'].pendingDisplayName
    }

    get name() {
        return this['payload'].name
    }

    get old() {
        try {
            let parsedJson = JSON.parse(this['payload'].old)

            if (parsedJson.type == 'editorjs' || parsedJson.type == 'text') {
                return new EditorJS(parsedJson)
            } else {
                return parsedJson
            }
        } catch (e) {
            return this['payload'].old
        }
    }

    get oldKept() {
        return false
        // this['payload'].hasOwnProperty('oldKept')
        //     ? this['payload'].oldKept
        //     : this['payload'].fileId
        //     ? true
        //         :
        //         false
    }

    get new() {
        try {
            let parsedJson = JSON.parse(this['payload'].new)

            if (parsedJson.type == 'editorjs' || parsedJson.type == 'text') {
                return new EditorJS(parsedJson)
            } else {
                return parsedJson
            }
        } catch (e) {
            return this['payload'].new
        }
    }

    get added() {
        return this['payload'].added
    }

    get _added() {
        return this.added.map((item) => item.name).join(', ')
    }

    get removed() {
        return this['payload'].removed
    }

    get _removed() {
        return this.removed.map((item) => item.name).join(', ')
    }

    get kind() {
        return this['payload']?.kind
    }

    get logEventName() {
        return this['eventName']
    }

    get logEventType() {
        let str = ''

        if (this.logEventName == 'projectUserCreated') {
            if (this.hasActingUser) str += '-hasActingUser'
            if (!this.hasActingUser) str += '-hasActingUser'
        }

        if (this.removed?.length == 0 && this.added?.length > 0) str += '-collectionAdded'
        if (this.added?.length == 0 && this.removed?.length > 0) str += '-collectionRemoved'

        if (String(this.new) == 'null') {
            str += '-removed'
        }

        if (String(this.old) == 'null') {
            str += '-added'
        }

        return str
    }

    get logTranslationStr() {
        return this.logEventType ? `${this.logEventName}${this.logEventType}` : this.logEventName
    }

    get instance() {
        return this
    }

    static async getLog(data: LogParam) {
        let query: any = {
            include: ['actingUser'],
            filters: data,
        }

        if (query.filters['filter[activityLogNumber]'])
            query.filters['filter[activityLogNumber]'] =
                query.filters['filter[activityLogNumber]'].join(',')
        if (query.filters['filter[eventName]'])
            query.filters['filter[eventName]'] = query.filters['filter[eventName]'].join(',')
        if (!query.filters['page[limit]']) query.filters['page[limit]'] = Log.limit

        let res = await Vue.prototype.$vbit.get('log', 'events', query)

        return res.data.map((user) => new Log(user, res.included))
    }
}
